import { useSelector } from 'react-redux'

import { facetByIdSelector } from 'client/store/facet'
import { filterOptionByIdSelector } from 'client/store/filterOption'
import { refinementsHasRefSelector } from 'client/store/refinement'

export const useFilterOptions = (filter: State.AttributeFilter): State.FilterOption => {
  const getFacet = useSelector(facetByIdSelector)
  const getOption = useSelector(filterOptionByIdSelector)
  const isSelected = useSelector(refinementsHasRefSelector)

  const options = filter.options
    .map((o: string) => {
      const facet = getFacet(o)
      const option = getOption(o) as RenderableFilterOption

      option.selected = !!isSelected(o)
      option.facetCount = 0
      option.disabled = !facet || facet.count <= 0
      return option
    })
    .filter((o) => o.facetCount != null)

  // only render the filter if there is at least one enabled item
  const visible = options.some((o) => !o.disabled)
  const selected = options.find((o) => !!o.selected)

  return {
    options,
    selected: selected?.value || '',
    visible,
  }
}
